































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';
import WaybillService from '@/services/waybill';

// --- Third Party imports ---
import VueRecaptcha from 'vue-recaptcha';

@Component({
  components: {
    BaseMaterialCard,
    VueRecaptcha,
  },
})
export default class PagesLogin extends Vue {

  styleMe: boolean = true;
  captchaVerified: boolean = false;

  loginCapture = {
    email: '',
    waybillNumber: '',
  };

  clicked: boolean = false;
  loader: boolean = false;
  valid: boolean = false;
  rules = {
    required: (value: string) => value != null && !!value.toString().trim() || '',
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'Please enter a valid E-mail Address',
  };

  beforeMount() {
    this.styleMe = this.$route.meta.styled;
  }

  getVersion() {
    return process.env.VUE_APP_VERSION_NUMBER;
  }

  getImageUrl() {
    return 'https://scrubbill-img.s3.af-south-1.amazonaws.com/img/' + (process.env.VUE_APP_ISLIVE === 'YES' ? '' : 'local/') + 'desktop_app.png';
  }

  getSiteKey() {
    return process.env.VUE_APP_GCAPTCHA_SITE_KEY;
  }

  resetCaptchaVerified() {
    this.captchaVerified = false;
  }

  verifyCaptcha(response: string) {
    this.captchaVerified = true;
  }

  async login() {
    this.clicked = true;

    try {

      const response = await AuthService.login({ email: this.loginCapture.email, waybillNumber: this.loginCapture.waybillNumber });

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          this.$store.dispatch('auth/setLoggedInState', {
            loggedIn: false,
          });
          this.$store.dispatch('auth/setToken', {
            token: '',
          });

          AppService.errorHandler(response.data.message);
        } else {
            this.$store.dispatch('auth/setLoggedInState', {
              loggedIn: true,
            });
            this.$store.dispatch('auth/setToken', {
              token: response.data.token,
            });  

            // before we redirect, go fetch all the Waybill data we need
            await WaybillService.getMyWaybill(true);
            this.$router.push(this.styleMe ? '/waybill' : '/waybill/iframe');
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      this.$store.dispatch('auth/setLoggedInState', {
        loggedIn: false,
      });
      this.$store.dispatch('auth/setToken', {
        token: '',
      });
      
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        await AuthService.logSupportDebug('Login.vue - login - 228 ' + error);
        AppService.errorHandler(this.$store.state.app.messages.couldNotConnect);
      }

    } finally {
      this.clicked = false;
    }
  }
}
